// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"11141cd5","498":"624eda96","703":"de6df5fe"}[chunkId] + ".chunk.js";
};